// https://eu.posthog.com/project/281/feature_flags?tab=overview
export const FeatureFlags = {
  Eurovision: 'eurovision',
  RemoteMicConnectionType: 'remote_mics_connection_type',
  InitialInputLag: 'initial_input_lag',
  NewVolume: 'new_volume',
  DisableMobileMode: 'disable_mobile_mode',
  DisableAutoFullscreen: 'disable_auto_fullscreen',
  InstantSongPreview: 'instant_song_preview',
  OnlineMode: 'online_mode',
  Leaderboard: 'leaderboard',
  SongLeaderboard: 'song_leaderboard',
  HideJukebox: 'hide_jukebox',
} as const;
